import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Divider, Tab } from 'semantic-ui-react';
import CurrencyDropDown from '../shared/CurrencyDropDown';
import NumericInput from '../shared/NumericInput';
import TimeReferenceDropDown from '../shared/TimeReferenceDropDown';
import { useTextResources } from '../../language';
import { propertiesEnum, sourceEnum } from './enums';
import './style.css';

const ReusablePane = ({
  policiesArray,
  setStateFunction,
  timeReference,
  onTimeReferenceChange,
  errors,
  source,
  onAddNewPolicy,
  onUpdatePolicy,
  onDeletePolicy,
}) => {
  const text = useTextResources();
  return (
    <Tab.Pane as={Form} key='ReusablePane' style={{ flex: 1 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Form.Field
          inline
          value={timeReference}
          onChange={(value) =>
            onTimeReferenceChange({ value, policiesArray, setStateFunction })
          }
          label={text('TimeReference')}
          control={TimeReferenceDropDown}
        />
        <Form.Button
          key='add'
          positive
          icon='plus'
          content='Add'
          size='mini'
          onClick={() => onAddNewPolicy(setStateFunction, policiesArray)}
        />
      </div>
      {policiesArray?.length ? (
        <Divider horizontal>{text('Policies')}</Divider>
      ) : null}
      {policiesArray?.map((policy, idx) => (
        <div
          key={policy.Id || policy.InternalId}
          className='policies'
          style={{ marginBottom: '4em' }}
        >
          <Form.Group>
            <Form.Field
              width={7}
              control={NumericInput}
              digits={0}
              value={policy.Percent}
              min={0}
              max={100}
              size='mini'
              label={text('Percent')}
              onChange={(value) =>
                onUpdatePolicy({
                  value,
                  policy,
                  property: propertiesEnum.Percent,
                  setStateFunction,
                  policiesArray,
                })
              }
              error={
                errors?.AmountOrPercentInDeposits?.[
                  policy.Id || policy.InternalId
                ]
                  ? {
                      content:
                        errors?.AmountOrPercentInDeposits?.[
                          policy.Id || policy.InternalId
                        ],
                      pointing: 'below',
                    }
                  : null
              }
            />
            <Form.Field
              width={2}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'end',
              }}
            >
              {source === sourceEnum.deposits && <div>{text('Or')}</div>}
            </Form.Field>{' '}
            <Form.Field
              width={7}
              control={NumericInput}
              value={policy.Amount}
              min={0}
              label={text('Amount')}
              size='mini'
              error={
                errors?.AmountOrPercentInDeposits?.[
                  policy.Id || policy.InternalId
                ] || errors?.Amount?.[policy.Id || policy.InternalId]
                  ? {
                      content:
                        errors?.AmountOrPercentInDeposits?.[
                          policy.Id || policy.InternalId
                        ] || errors?.Amount?.[policy.Id || policy.InternalId],
                      pointing: 'below',
                    }
                  : null
              }
              onChange={(value) =>
                onUpdatePolicy({
                  value,
                  policy,
                  property: propertiesEnum.Amount,
                  setStateFunction,
                  policiesArray,
                })
              }
            />
          </Form.Group>

          <Form.Group style={{ justifyContent: 'space-between' }}>
            <Form.Field
              width={7}
              label={text('Currency')}
              control={CurrencyDropDown}
              textField='Name'
              descriptionField='Symbol'
              value={policy.CurrencyId}
              error={
                errors?.Currency?.[policy.Id || policy.InternalId]
                  ? {
                      content:
                        errors.Currency?.[policy.Id || policy.InternalId],
                      pointing: 'above',
                    }
                  : null
              }
              onChange={(value) =>
                onUpdatePolicy({
                  value,
                  policy,
                  property: propertiesEnum.CurrencyId,
                  setStateFunction,
                  policiesArray,
                })
              }
            />
            <Form.Field
              width={7}
              control={NumericInput}
              value={policy.Days}
              size='mini'
              digits={0}
              onChange={(value) =>
                onUpdatePolicy({
                  value,
                  policy,
                  property: propertiesEnum.Days,
                  setStateFunction,
                  policiesArray,
                })
              }
              error={
                errors?.Days?.[policy.Id || policy.InternalId]
                  ? {
                      content: errors.Days?.[policy.Id || policy.InternalId],
                      pointing: 'below',
                    }
                  : null
              }
              label={`${text(
                timeReference == 0 ? 'DaysBeforeArrival' : 'DaysAfterArrival'
              )}:`}
            />
          </Form.Group>
          <Button
            style={{ marginBottom: '1em' }}
            size='mini'
            floated='right'
            negative
            icon='minus'
            content='Remove'
            onClick={() =>
              onDeletePolicy({ policiesArray, policy, setStateFunction })
            }
          />
          {idx == policiesArray.length - 1 ? null : ( //If item is not the last, add divider
            <Divider clearing section />
          )}
        </div>
      ))}
    </Tab.Pane>
  );
};

ReusablePane.propTypes = {
  timeReference: PropTypes.number,
  errors: PropTypes.object,
  source: PropTypes.string,
  onTimeReferenceChange: PropTypes.func,
  onAddNewPolicy: PropTypes.func,
  onUpdatePolicy: PropTypes.func,
  onDeletePolicy: PropTypes.func,
  policiesArray: PropTypes.array,
  setStateFunction: PropTypes.func,
};

export default ReusablePane;
